import { local } from '../../../../mixins/environment';
import { FortnitePlayerData, fortniteStatsMock, fortniteStatsMock2, generateDailyActivity } from '../models/FortnitePlayerData';
import axios from 'axios';
import store from '../../../index';

const actionNameErrorsMap = {
  'general': 'getGeneralStats',
  'rank': 'getRankStats',
  'activity': 'getActivityStats',
};

export default {
  getProfileData(boomAccountId) {
    const url = `${store.state.app.config.baseUrl}/api/v1/fortnite/profile/`;

    if (!local) {
      return axios.get(
        url,
        { params: { boomAccountId }}
      ).then(({ data }) => {
        const queues = data.general ? data.general.queues : undefined;
        const rankProgression = data.activity ? data.activity.rankProgression : undefined;
        return {
          gameStats: new FortnitePlayerData({
            ...data,
            queues,
            rankProgression,
          }),
          actionNameErrors: data.errors.map(error => actionNameErrorsMap[error]),
        };
      }).catch(() => {
        throw new Error('error');
      });
    }

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const response = boomAccountId !== 9999999 ? { ...fortniteStatsMock } : { ...fortniteStatsMock2 };

        let errors = []; // Posible errors: ['activity', 'general', 'rank' ];

        // Just for testing compare failures.
        if (boomAccountId === 9999999) {
          // errors = ['general'];
        }

        errors = errors.map(error => actionNameErrorsMap[error]);

        const queues = response.general ? response.general.queues : undefined;
        const rankProgression = response.activity ? response.activity.rankProgression : undefined;
        resolve({
          gameStats: new FortnitePlayerData({
            ...response,
            queues,
            rankProgression,
          }),
          actionNameErrors: errors,
        });
      }, 1000);
    });
  },

  getActivityStats(boomAccountId) {
    const url = `${store.state.app.config.baseUrl}/api/v1/fortnite/profile/activity`;

    if (!local) {
      return axios.get(
        url,
        { params: { boomAccountId }}
      ).then(({ data }) => {
        return data;
      }).catch(() => {
        throw new Error('error');
      });
    }

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const response = {
          dailyActivity: generateDailyActivity(),
          weekActivity: {
            'hoursPlayed': 40,
            'change': 79.89,
          },
          monthActivity: {
            'hoursPlayed': 142,
            'change': 140,
          },
          rankProgression: [
            {
              date: '1594684800',
              score: 240,
            }, {
              date: '1594771200',
              score: 500,
            },
          ],
        };

        resolve(response);
      }, 800);
    });
  },

  getGeneralStats(boomAccountId) {
    const url = `${store.state.app.config.baseUrl}/api/v1/fortnite/profile/general`;

    if (!local){
      return axios.get(
        url,
        { params: { boomAccountId }}
      ).then(({ data }) => {
        return data;
      }).catch(() => {
        throw new Error('error');
      });
    }

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const response = {
          playerName: 'Seadawg',
          matches: 2490,
          wins: 99,
          winRatio: 30,
          avgKills: 20,
          avgPlacement: 2,
          avgPerformance: 247,
          others: {
            avgKills: 13,
            avgPlacement: 10,
          },
          queues: {
            solo: {
              'matches': 999,
              'wins': 200,
              'avgKills': 12,
              'avgPlacement': 78,
            },
            duo: {
              'matches': 350,
              'wins': 33,
              'avgKills': 23,
              'avgPlacement': 40,
            },
            squad: {
              'matches': 78,
              'wins': 7,
              'avgKills': 5,
              'avgPlacement': 11,
            },
          },
        };

        resolve(response);
      }, 800);
    });
  },

  getRankStats(boomAccountId) {
    const url = `${store.state.app.config.baseUrl}/api/v1/fortnite/profile/rank`;

    if (!local) {
      return axios.get(
        url,
        { params: { boomAccountId }}
      ).then(({ data }) => {
        return data;
      }).catch(() => {
        throw new Error('error');
      });
    }

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const response = {
          overrall: 1,
          hub: 2,
          state: 3,
          country: 4,
          gameRank: 'Silver 3',
          selectedHub: '4',
        };

        resolve(response);
      }, 800);
    });
  },

};
